import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import '../../css/pratibedan.css'
import axios from 'axios'

const PEARLS = () => {

    axios.defaults.withCredentials = true;

    const [reportList, setReportList] = useState([]);

    const fetchReports = async () => {
        try {
            const response = await axios(`${process.env.REACT_APP_API_URL}/pearlsreport`);
            if (response.data.status === "Success") {
                setReportList(response.data.reportDetail);
            }
            else {
                console.error("Unable to get data!", response.data.errorDetail);
            }
        }
        catch (error) {
            console.error("Error Fetching Data!", error);
        }
    }

    const handleOpenPdf = (data) => {
        const pdfUrl = `${process.env.REACT_APP_IMG_URL}/reports/pearls/${data}`;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
    }

    reportList.sort((a, b) => {
        // Assuming year is a string, convert it to a number for comparison
        return Number(b.id) - Number(a.id);
    });

    useEffect(() => {
        fetchReports();
    }, [])

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='report-body'>
                    <div className='report-header'>
                        <h3>पर्ल्स प्रतिवेदन</h3>
                    </div>
                    <div className='bg-white rounded shadow report-table-body'>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>S.N.</th>
                                    <th>Title</th>
                                    <th>Year</th>
                                    <th>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportList.length > 0 ? (
                                    reportList.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.Title}</td>
                                            <td>{item.Year}</td>
                                            <td>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.PdfUrl)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>No Record Found In Server!</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default PEARLS